import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const ReallocCalcChart = ({ formValues, origLines, calcType }) => {

  let { calcId, trxSrcCode } = formValues;

  const rsrc = useRsrc();

  const { navigateTo } = useNavState();

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!calcId) {
      return;
    }

    const origColors = ['#0F766E', '#2DD4BF']
    const reallocColors = ['#14B8A6', '#0EA5E9'];

    rsrc.data('gp', 'REALLOC_CALC_CHART_DATA_PLUGIN', { calcId, origLines, trxSrcCode, calcType }).then(res => {
      setData({
        ...res,
        series: (res.series || []).map((s, i) => ({
        ...s,
        color: origLines ? origColors[i] : reallocColors[i],
        })),
      });
    });

  }, [calcId, trxSrcCode]);

  const navigateToReallocCalcTrxViewer = (dataPoint) => {
    navigateTo('gp/realloc-viewer', { viewerReqParam: { data: {calcId: calcId, ndc11: dataPoint.series.name}, calc: {id: calcId}, trxSrcCode: trxSrcCode, orig: origLines }, entity: 'REALLOC_RATIO' });
  }

  return (
    <>
        <CartesianChart
          data={data}
          yLabel="Amount"
          xLabel="Amount Type"
          allowNegative
          stacked={true}
          onClick={(dataPoint) => navigateToReallocCalcTrxViewer(dataPoint)}
        />
    </>

  );
};
